import { css } from '@emotion/react'
import styled from '@emotion/styled'
import {
  breakpoint,
  duration,
  size,
} from '@twistopayments/design-system/styles'

export const storiesContainer = css`
  display: grid;
  grid-template-columns: 1fr;
  list-style: none;
  padding-left: 0;
  margin-top: ${size[32]};
  margin-bottom: ${size[48]};
  row-gap: 10px;

  ${breakpoint.up('smMd')} {
    margin-top: ${size[90]};
    margin-bottom: ${size[72]};
    column-gap: ${size[18]};
    row-gap: ${size[20]};
    grid-template-columns: repeat(3, minmax(auto, 394px));
  }
`
export const PlayButton = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity ${duration.standard}ms;
  svg {
    width: 50px;
    height: 50px;
  }
`

export const story = css`
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    border-radius: 10px;
  }

  &:hover ${PlayButton} {
    opacity: 1;
  }
`
export const storyInfo = css`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 20px;
  bottom: 0;
  z-index: 2;
  color: #fff;
`

export const video = css`
  max-width: 840px;
  width: 100%;

  video {
    width: 100%;
  }
`
